import { Box, Button, Flex, Text } from '@mantine/core'
import { IconFilterCustomers } from '../../../../icons/x-symbol-svgrepo-com'
import { MAIN_DARK_PRIMARY } from '../../../../constants/colors'
import { useContext } from 'react'
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext'

const MainTitle = () => {

  const { handleModalOpen } = useContext(SingleCustomerContext)


  return (
    <Flex justify='space-between' align='flex-end' h={32} /* mb={24} */>
      <Text fz={20} fw={600} color={MAIN_DARK_PRIMARY} align="start">
       Customer 360
      </Text>
      <Box>
        <Button
          mr={7}
          fz="12px"
          w={144}
          leftIcon={<IconFilterCustomers />}
          onClick={handleModalOpen}
          styles={(theme) => ({
            root: {
              height: "32px",
              backgroundColor: "#5C5CEB",
              border: 0,
              fontWeight: 400,
              padding: "0px 5px",
              margin: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              "&:hover": {
                backgroundColor: theme.fn.darken("#5353D3", 0.05),
              },
            },

            loader: {
              position: "absolute",
              color: theme.white,
            },

            leftIcon: {
              marginRight: 15,
            },
          })}
        >
          <Text fz={12}>
        Select customer/s
          </Text>
      
        </Button>
      </Box>
      
    </Flex>
   
  )
}

export default MainTitle